// /pages/carrossier/FormulaireRouter.js - VERSION CORRIGÉE
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { app } from "../../firebaseConfig";

// Import des deux types de formulaires
import FormulaireTypeA from "./FormulaireA";
import FormulaireTypeB from "./FormulaireB";

const FormulaireRouter = ({ onComplete, produit, index }) => {
  const { orderId, produitId } = useParams();
  const [loading, setLoading] = useState(true);
  const [produitData, setProduitData] = useState(null);
  const [formulaireType, setFormulaireType] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const determineFormulaireType = async () => {
      try {
        console.log("🔍 Détermination du type de formulaire pour:", { orderId, produitId });

        // 1. Si on a déjà les données du produit en props
        if (produit?.name) {
          const type = getFormulaireTypeFromName(produit.name);
          setFormulaireType(type);
          setProduitData(produit);
          setLoading(false);
          return;
        }

        // 2. Sinon, récupérer depuis Firebase
        const db = getFirestore(app);
        const dossierRef = doc(db, "dossiers", orderId);
        const dossierSnap = await getDoc(dossierRef);

        if (!dossierSnap.exists()) {
          throw new Error("Dossier non trouvé");
        }

        const dossierData = dossierSnap.data();
        console.log("📋 Données dossier récupérées:", dossierData);

        // 3. Trouver le produit correspondant
        let foundProduct = null;

        if (dossierData.produits && Array.isArray(dossierData.produits)) {
          // Essayer de trouver par ID exact
          foundProduct = dossierData.produits.find(p => 
            p.productId === produitId || 
            p.uuid === produitId || 
            p.id === produitId
          );

          // Si pas trouvé, essayer par nom encodé
          if (!foundProduct) {
            foundProduct = dossierData.produits.find(p => 
              encodeURIComponent(p.name?.toLowerCase() || "") === produitId
            );
          }

          // Si toujours pas trouvé, prendre par index
          if (!foundProduct && index !== undefined) {
            foundProduct = dossierData.produits[index];
          }
        }

        if (!foundProduct) {
          throw new Error(`Produit non trouvé: ${produitId}`);
        }

        console.log("✅ Produit trouvé:", foundProduct);

        // 4. Déterminer le type de formulaire
        const type = getFormulaireTypeFromName(foundProduct.name);
        setFormulaireType(type);
        setProduitData(foundProduct);

      } catch (err) {
        console.error("❌ Erreur lors de la détermination du type:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    determineFormulaireType();
  }, [orderId, produitId, produit, index]);

  // 🔧 FONCTION CORRIGÉE : Déterminer le type de formulaire selon le nom du produit
  const getFormulaireTypeFromName = (productName) => {
    const name = productName?.toLowerCase() || "";
    
    console.log("🔍 Analyse du nom produit:", name);

    // 🔥 RÈGLE SIMPLE : SEULEMENT "HUSKY" → FormulaireB, TOUT LE RESTE → FormulaireA
    if (name.includes('husky')) {
      console.log("✅ Détecté comme FormulaireB (HUSKY)");
      return 'B';
    }

    // Tout le reste = FormulaireA (Standard)
    console.log("✅ Détecté comme FormulaireA (Standard)");
    return 'A';
  };

  // États de chargement et d'erreur
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center">
        <div className="text-center space-y-4">
          <div className="relative">
            <div className="w-16 h-16 border-4 border-orange-200 rounded-full animate-spin"></div>
            <div className="w-16 h-16 border-4 border-orange-600 border-t-transparent rounded-full animate-spin absolute top-0 left-0"></div>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Chargement du formulaire</h3>
            <p className="text-gray-600">Détermination du type de contrôle...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-6xl mx-auto p-8">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6">
          <h3 className="text-red-800 font-semibold mb-2">❌ Erreur de chargement</h3>
          <p className="text-red-700 mb-4">{error}</p>
          <button
            onClick={() => window.history.back()}
            className="mt-4 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
          >
            ← Retour au dashboard
          </button>
        </div>
      </div>
    );
  }

  // Rendu du bon formulaire selon le type déterminé
  const FormulaireComponent = formulaireType === 'B' ? FormulaireTypeB : FormulaireTypeA;
  
  return (
    <div>
      {/* Debug info - Version épurée */}
      <div className="max-w-6xl mx-auto p-4 mb-4">
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
          <div className="text-sm text-blue-800">
            <strong>🔍 Contrôle montage et mise en service:</strong> {produitData?.name}
          </div>
        </div>
      </div>

      {/* Formulaire approprié */}
      <FormulaireComponent 
        onComplete={onComplete}
        produit={produitData}
        index={index}
      />
    </div>
  );
};

export default FormulaireRouter;